import { combineReducers } from 'redux'

import {
  MAKE_EV_DATA,
  MAKE_RANDOM_EV_DATA,
  CHGR_CNT
} from 'actions/settings';



const initSimuSettings = {
  simu_env: {},
  random_ev_data: {},
  chgr_cnt:0,
}


const simuSettings = (state = initSimuSettings, action) => {

  switch(action.type){
    // case MAKE_EV_DATA:
    //   return { ...state, make_ev_data: action.payload};

    case MAKE_RANDOM_EV_DATA:
      return {...state, random_ev_data: action.payload};

    case CHGR_CNT:
      return {...state, chgr_cnt: action.payload};

    default: return state;
  }
}


const rootReducer = combineReducers({
  simuSettings,
});

export default rootReducer;

